import { Injectable } from '@angular/core'; 

@Injectable({
    providedIn: 'root'
})
export class ErrorHttpService {


    isError: boolean = false;
    content: any;
   
   
}
